import { Component } from 'react';

/**
 * Silent error boundary specifically for the WebGL canvas.
 * If R3F throws (which can happen with the dev React error overlay),
 * we silently swallow it and render a transparent fallback so the
 * rest of the page stays usable.
 */
export default class R3FErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[R3F] non-fatal error suppressed:', err?.message);
    }
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
